/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerResponse } from './';
import {
    FreelancerResponseFromJSON,
    FreelancerResponseFromJSONTyped,
    FreelancerResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchFreelancerAccountResponse
 */
export interface SearchFreelancerAccountResponse {
    /**
     * 
     * @type {Array<FreelancerResponse>}
     * @memberof SearchFreelancerAccountResponse
     */
    freelancers: Array<FreelancerResponse>;
}

/**
 * Check if a given object implements the SearchFreelancerAccountResponse interface.
 */
export function instanceOfSearchFreelancerAccountResponse(value: object): value is SearchFreelancerAccountResponse {
    if (!('freelancers' in value) || value['freelancers'] === undefined) return false;
    return true;
}

export function SearchFreelancerAccountResponseFromJSON(json: any): SearchFreelancerAccountResponse {
    return SearchFreelancerAccountResponseFromJSONTyped(json, false);
}

export function SearchFreelancerAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFreelancerAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancers': ((json['freelancers'] as Array<any>).map(FreelancerResponseFromJSON)),
    };
}

export function SearchFreelancerAccountResponseToJSON(value?: SearchFreelancerAccountResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancers': ((value['freelancers'] as Array<any>).map((v) => FreelancerResponseToJSON(v))),
    };
}

